import { TFunction } from "i18next";
import * as yup from "yup";
import { InferType } from "yup";

const addValidationSchema = (t: TFunction, isEditMode: boolean = false) => {
  return yup.lazy(() => {
    const schemaFields: yup.ObjectShape = {
      name: yup
        .string()
        .required(t("validations.required"))
        .min(2, t("validations.min_length", { count: 2 }))
        .max(50, t("validations.max_length", { count: 50 })),
      status: yup.string().required("This field is required"),
      type: yup.string().required(t("validations.required")),
      actions: yup
        .array()
        .of(yup.string())
        .required(t("validations.required"))
        .min(1, t("validations.validator_min_items", { count: 1 })),
    };

    return yup.object().shape(schemaFields);
  });
};

export type AddRoleFormData = InferType<ReturnType<typeof addValidationSchema>>;

export default addValidationSchema;
